import React, { useEffect, useState } from 'react';
import { NavLink, useLocation, useHistory } from 'react-router-dom';
import './Sidebar.scss'; // for styling
import {
  AddToDrive,
  AssignmentIndOutlined,
  AssignmentTurnedIn,
  AutoAwesome,
  AutoStories,
  BarChart,
  BookmarkAdded,
  CampaignOutlined,
  Chat,
  Class,
  Contacts,
  CurrencyRupee,
  Dashboard,
  EmojiEvents,
  GroupAdd,
  Home,
  ImportContactsOutlined,
  LaptopChromebook,
  ListAltOutlined,
  NoteAlt,
  People,
  PersonAdd,
  PersonOutlineOutlined,
  QuestionMarkSharp,
  SchoolOutlined,
  StarBorder,
  Tv,
  VideoCameraFront,
} from '@mui/icons-material';
import PageHeaderNew from '../Components/Common/PageHeader/PageHeaderNew';
import { getCurrentDashboardData } from '../redux/reducers/dashboard.reducer';
import { connect } from 'react-redux';
import {
  getAppLanguage,
  getClientUserId,
  getRoleArray,
} from '../redux/reducers/clientUserId.reducer';
import { analysisActions } from '../redux/actions/analysis.action';
import { get } from '../Utilities';
import BackdropLoader from '../Components/Common/BackdropLoader/BackdropLoader';
import { studyBinActions } from '../redux/actions/studybin.actions';
import { homeworkActions } from '../redux/actions/homework.action';
import { Button, Modal } from 'react-bootstrap';

const Sidebar = (props) => {
  const {
    dashboardData,
    roleArray,
    setAnalysisStudentObjectToStore,
    setFolderIdArrayToStore,
    clientUserId,
    clearTests,
    appLanguage,
  } = props;
  const history = useHistory();
  const location = useLocation();

  const [features, setFeatures] = useState([]);
  const [active, setActive] = useState('home');
  const [isLoading, setIsLoading] = useState(false);
  const [formCompulsaryModal, setFormCompulsaryModal] = useState(false);
  const [globalNotificationCount, setGlobalNotificationCount] = useState(0);

  // Manage active tab based on current URL path
  useEffect(() => {
    setTimeout(() => {
      setFormCompulsaryModal(
        dashboardData.form_compulsory === 'true' && dashboardData.admission_form_filled === 'false',
      );
    }, 1000);
    get({ client_user_id: clientUserId }, '/getTotalUnReadMessageCountOfUser').then((res) => {
      if (res && res.success) {
        setGlobalNotificationCount(res.result);
      }
    });
    const path = location.pathname;

    // alert(path);
    if (path === '/') {
      setActive('home');
    } else if (
      path.startsWith('/courses/teachercourse') ||
      (path.startsWith('/course/editcourse') && (roleArray.includes(3) || roleArray.includes(4)))
    ) {
      setActive('courses');
    } else if (path.startsWith('/allcourses') && roleArray.includes(1)) {
      const type = typeof location.state === 'object' ? location.state?.type : null;
      if (type === 'allCourses') {
        setActive('courses');
      } else {
        setActive('myCourses');
      }
    } else if (path.startsWith('/attendance')) {
      setActive('attendance');
    } else if (path.startsWith('/noticeboard')) {
      setActive('noticeBoard');
    } else if (path.startsWith('/usage')) {
      setActive('usage');
    } else if (path.startsWith('/campaign-dashboard')) {
      setActive('campaign');
    } else if (path.startsWith('/forms')) {
      setActive('forms');
    } else if (path.startsWith('/credits-analytics')) {
      setActive('referral_and_reward');
    } else if (path.startsWith('/v2/homework')) {
      setActive('homeworkCreator');
    } else if (path.startsWith('/analysis')) {
      setActive('analysis');
    } else if (path.startsWith('/offlineassignments')) {
      setActive('offlineAssignment');
    } else if (path.startsWith('/teacherfees') || path.startsWith('/fees')) {
      setActive('fees');
    } else if (path.startsWith('/liveclasses')) {
      setActive('liveClasses');
    } else if (path.startsWith('/studybin')) {
      setActive('studyBin');
      // setFolderIdArrayToStore([]);
    } else if (path.startsWith('/crm')) {
      setActive('crm');
    } else if (path.startsWith('/usage')) {
      setActive('Usage');
    } else if (path.startsWith('/admissions')) {
      setActive('admission');
    } else if (path.startsWith('/allassignments')) {
      setActive('onlineAssignment');
    } else if (path.startsWith('/displaypage')) {
      setActive('displayPage');
    } else if (path.startsWith('/v2/homework')) {
      setActive('create_questions');
    } else if (path.startsWith('/all-appointments')) {
      setActive('booking');
    } else if (path.startsWith('/v2/test')) {
      setActive('tests');
    } else if (path.startsWith('/practice')) {
      setActive('practice');
    } else if (path.startsWith('/go-pro')) {
      setActive('gopro');
    } else if (path.startsWith('/mulyankan-profile')) {
      setActive('profile');
    }
  }, [location.pathname]);

  const goToStudentAnalysis = () => {
    setIsLoading(true);
    get({ client_user_id: clientUserId }, '/getOverallAnalysisOfStudent').then((res) => {
      if (res && res.success) {
        const result = res.result;
        // result.first_name = firstName;
        // result.last_name = lastName;
        result.isStudent = true;
        setIsLoading(false);
        setAnalysisStudentObjectToStore(result);
        history.push('/analysis/studentlist');
      }
    });
  };

  const goToAllCourses = () => {
    setIsLoading(true);
    setActive('courses');
    setIsLoading(false);
    history.push({ pathname: '/allcourses', state: { type: 'allCourses' } });
  };

  const goToMyCourses = () => {
    setIsLoading(true);
    setActive('myCourses');
    setIsLoading(false);
    history.push({ pathname: '/courses', state: { type: 'myCourses' } });
  };

  const goToHomeWorkCreator = () => {
    clearTests();
    history.push({ pathname: '/v2/homeworkcreator', state: { letsGo: true } });
  };

  useEffect(() => {
    if (dashboardData?.featureOrder) {
      const featuresArray = dashboardData?.featureOrder
        .filter((ele) =>
          [
            'attendance',
            'noticeBoard',
            'homeworkCreator',
            'analysis',
            'offlineAssignment',
            'campaign',
            'fees',
            'courses',
            'forms',
            'referral_and_reward',
            'myCourses',
            'liveClasses',
            'onlineAssignment',
            'studyBin',
            'crm',
            'Usage',
            'admission',
            'displayPage',
            'create_questions',
            'booking',
            'tests',
            'profile',
            'practice',
            'gopro',
          ].includes(ele),
        )
        .map((ele) => {
          if (!dashboardData.feature) return null;
          const featureObject =
            dashboardData.feature[Object.keys(dashboardData.feature).find((elem) => elem === ele)];
          const name =
            featureObject?.client_feature_name_object?.[`${appLanguage}`] ||
            featureObject?.client_feature_name_object?.[`1`] ||
            featureObject?.client_feature_name;
          switch (ele) {
            case 'attendance':
              return {
                icon: <People />,
                name,
                route: '/attendance',
                key: ele,
              };
            case 'noticeBoard':
              return {
                icon: <NoteAlt />,
                name,
                route: '/noticeboard',
                key: ele,
              };
              case 'forms':
              return {
                icon: <ListAltOutlined />,
                name,
                route: '/forms',
                key: ele,
              };
            case 'booking':
              return {
                icon: <BookmarkAdded />,
                name,
                route: '/all-appointments',
                key: ele,
              };
            case 'homeworkCreator':
              return {
                icon: <SchoolOutlined />,
                name: 'Create Test',
                route: '/v2/homeworkcreator',
                key: ele,
              };
            case 'create_questions':
              return {
                icon: <AutoStories />,
                name: 'My Question Bank',
                route: '/v2/homeworkcreator',
                key: ele,
              };
            case 'analysis':
              return roleArray.includes(4) || roleArray.includes(5)
                ? {
                    icon: <AssignmentIndOutlined />,
                    name,
                    route: '/analysis/teacher',
                    key: ele,
                  }
                : {
                    icon: <AssignmentIndOutlined />,
                    name,
                    route: '/analysis/studentlist',
                    key: ele,
                  };
            case 'offlineAssignment':
              return {
                icon: <Home />,
                name,
                route: '/offlineassignments',
                key: ele,
              };
            case 'campaign':
              return {
                icon: <CampaignOutlined />,
                name,
                route: '/campaign-dashboard',
                key: ele,
              };
            case 'fees':
              return roleArray.includes(4) || roleArray.includes(5)
                ? {
                    icon: <CurrencyRupee />,
                    name,
                    route: '/teacherfees',
                    key: ele,
                  }
                : {
                    icon: <CurrencyRupee />,
                    name,
                    route: '/fees',
                    key: ele,
                  };
            case 'courses':
              return roleArray.includes(1) || roleArray.includes(2)
                ? {
                    icon: <Class />,
                    name,
                    route: '/allcourses',
                    key: ele,
                  }
                : {
                    icon: <Class />,
                    name,
                    route: '/courses/teachercourse',
                    key: ele,
                  };
            case 'myCourses':
              return {
                icon: <LaptopChromebook />,
                name,
                route: '/courses',
                key: ele,
              };
            case 'liveClasses':
              return {
                icon: <VideoCameraFront />,
                name,
                route: '/liveclasses',
                key: ele,
              };
            case 'onlineAssignment':
              return {
                icon: <AssignmentTurnedIn />,
                name,
                route: '/allassignments',
                key: ele,
              };
            case 'studyBin':
              return {
                icon: <AddToDrive />,
                name,
                route: '/studybin',
                key: ele,
              };
            case 'crm':
              return {
                icon: <AutoAwesome />,
                name,
                route: '/crm',
                key: ele,
              };
            case 'Usage':
              return {
                icon: <BarChart />,
                name: 'Usage',
                route: '/usage',
                key: ele,
              };
            case 'admission':
              return {
                icon: <GroupAdd />,
                name,
                route: '/admissions',
                key: ele,
              };
            case 'displayPage':
              return {
                icon: <Tv />,
                name,
                route: '/displaypage',
                key: ele,
              };
            case 'tests':
              return {
                icon: <AssignmentIndOutlined />,
                name,
                route: '/v2/test',
                key: ele,
              };
            case 'practice':
              return {
                icon: <ImportContactsOutlined />,
                name,
                route: '/practice',
                key: ele,
              };
            case 'gopro':
              return {
                icon: <StarBorder />,
                name,
                route: '/go-pro',
                key: ele,
              };
            case 'referral_and_reward':
              return {
                icon: <EmojiEvents />,
                name,
                route: '/credits-analytics',
                key: ele,
              };
            case 'profile':
              return {
                icon: <PersonOutlineOutlined />,
                name,
                route: '/mulyankan-profile',
                key: ele,
              };
            default:
              return null;
          }
        })
        .filter(Boolean);

      setFeatures(featuresArray);
    }
  }, [dashboardData, roleArray]);

  return (
    <div id='sidebarId' className='Sidebar__sidebar px-3'>
      <PageHeaderNew isClientColor={false} history={history} />
      <BackdropLoader isLoading={isLoading} />
      <nav className='Sidebar__nav_links'>
        <NavLink
          exact
          style={{ top: '1px', marginTop: '20px' }}
          to='/'
          className={active === 'home' ? 'Sidebar__link Sidebar__active' : 'Sidebar__link'}
        >
          <div className='Sidebar__navButton'>
            <Dashboard />
            <span>Dashboard</span>
          </div>
        </NavLink>

        {features.map((ele, index) => {
          let eleStyle = { top: '1px' };
          if (index > 3) {
            eleStyle = { bottom: '1px ' };
          }
          return (
            <NavLink
              key={ele.key}
              to={ele.route || '#'}
              onClick={(e) => {
                if (!ele.route) e.preventDefault(); // prevent '#' or '' from triggering
                if (ele.route)
                  if (ele.key === 'analysis') {
                    if (roleArray.includes(1) || roleArray.includes(2)) {
                      e.preventDefault();
                      goToStudentAnalysis();
                    } else {
                    }
                  } else if (ele.key === 'courses' && roleArray.includes(1)) {
                    e.preventDefault();
                    goToAllCourses();
                  } else if (ele.key === 'myCourses' && roleArray.includes(1)) {
                    e.preventDefault();
                    goToMyCourses();
                  } else if (ele.key === 'homeworkCreator') {
                    e.preventDefault();
                    goToHomeWorkCreator();
                  }
              }}
              style={eleStyle}
              className={active === ele.key ? 'Sidebar__link Sidebar__active' : 'Sidebar__link'}
            >
              <div className='Sidebar__navButton '>
                {ele.icon} <span>{ele.name}</span>
              </div>
            </NavLink>
          );
        })}
        <br />
        <br />
        <br />
        <br />
        <br />
        <br />
        <div className='Sidebar__chatNav'>
          {dashboardData?.featureOrder?.includes('chats') && (
            <NavLink
              exact
              to='/conversations'
              className={active === 'chats' ? 'Sidebar__link Sidebar__active' : 'Sidebar__link'}
            >
              <div
                style={{ border: '1px solid var(--primary-blue)', borderRadius: '12px' }}
                className='Sidebar__navButton primary-text py-0'
              >
                <Chat />
                <span>Let's Chat</span>
              </div>
              {Number(globalNotificationCount) > 0 && (
                <div className='Sidebar__notiCount'>
                  {globalNotificationCount < 100 ? globalNotificationCount : '99+'}
                </div>
              )}
            </NavLink>
          )}
        </div>
      </nav>

      <Modal size='md' show={formCompulsaryModal} backdrop='static' centered>
        <Modal.Header
          style={{ borderRadius: '0.9rem 0.9rem 0rem 0rem' }}
          className='primary-background text-white justify-content-center'
        >
          <Modal.Title className='fs-5 fw-bold font'>YTSE Registration</Modal.Title>
        </Modal.Header>
        <Modal.Body className='text-center px-4 py-3'>
          <p className='text-muted mb-4 font'>Fill your YTSE registration details.</p>
          <Button
            onClick={() => history.push('/admissionform')}
            variant='customPrimary'
            className='rounded-pill px-4 py-2 fw-semibold shadow-sm'
          >
            Let&apos;s do it
          </Button>
        </Modal.Body>
      </Modal>
    </div>
  );
};

const mapStateToProps = (state) => ({
  dashboardData: getCurrentDashboardData(state),
  roleArray: getRoleArray(state),
  clientUserId: getClientUserId(state),
  appLanguage: getAppLanguage(state),
});

const mapDispatchToProps = (dispatch) => {
  return {
    setAnalysisStudentObjectToStore: (payload) => {
      dispatch(analysisActions.setAnalysisStudentObjectToStore(payload));
    },
    setFolderIdArrayToStore: (payload) => {
      dispatch(studyBinActions.setFolderIDArrayToStore(payload));
    },
    clearTests: (payload) => {
      dispatch(homeworkActions.clearTests(payload));
    },
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(Sidebar);
